@if (adminData && adminData.length && adminData.length > 1) {
  <div class="main-container">
    <div class="savebtn">
      <button mat-button class="btn-action btn-update" (click)="adminSaveAPi()" [disabled]="saveButtonDisabled">SAVE</button>
    </div>
    <h2 class="pt-32">Default Settings</h2>
    <div class="admin-container">
      @for (item of InitialLevel; track item; let i = $index) {
        <div>
          <div>
            @if (item.key !== 'contact' && item.key !== 'companyaddress') {
              <div class="border-line">
                <!-- Exclude items with keys "contact" and "companyaddress" -->
                <ng-container>
                  <div class="icon-column">
                    <mat-icon class="icon-container">{{ item.iconPath }}</mat-icon>
                  </div>
                  <div class="label-column">
                    <mat-label>{{ item.displayName }}</mat-label>
                    @if (item.key === 'defaultturnaroundtime') {
                      <div >
                        <span class="custom-label">
                          Please modify the value(s) only after the working hours are over, so that the changes
                          are correctly reflected in the application.
                        </span>
                      </div>
                    }
                  </div>
                  <div class="input-column">
                    <mat-form-field class="headerlevel-input" appearance="outline">
                      <input
                        matInput
                        [(ngModel)]="item.value"
                        style="text-align: end"
                        (keypress)="validatenumberOnly($event)"
                        (ngModelChange)="checkInputsFilled()"
                        maxlength="3"
                        (blur)="onBlur($event, item.key)"/>
                      </mat-form-field>
                    </div>
                  </ng-container>
                </div>
              }
              <p class="rush-error-message">
                <span id="{{item.key}}-error" class="error-message"></span>
              </p>
            </div>
          </div>
        }
        <!--company address-->
        @for (item of adminData; track item) {
          @if (item.key === 'companyaddress') {
            <div class="sub-form">
              <div class="company-address-container">
                <mat-icon class="icon-container">{{ item.iconPath }}</mat-icon>
                <mat-label class="label">{{ item.displayName }}</mat-label>
                <div style="margin-top: 30px"></div>
                @for (subItem of companyAddress; track subItem) {
                  <div style="margin-top: 10px"></div>
                  @if (showCompanyAddres(subItem.key)) {
                    <div
                      class="sub-input">
                      <mat-form-field appearance="outline" class="c_label">
                        <input
                          matInput
                          [(ngModel)]="subItem.value"
                          [placeholder]="subItem.displayName"
                          (ngModelChange)="checkInputsFilled()"
                          maxlength="50" />
                        </mat-form-field>
                      </div>
                    }
                    <div style="margin-top: 10px"></div>
                    <div >
                      @if (subItem.key === 'state') {
                        <div class="state-code first">
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              [(ngModel)]="subItem.value"
                              [placeholder]="subItem.displayName"
                              maxlength="50"
                              (ngModelChange)="checkInputsFilled()"
                              />
                            </mat-form-field>
                          </div>
                        }
                        @if (subItem.key === 'zipcode') {
                          <div class="state-code last">
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                [(ngModel)]="subItem.value"
                                [placeholder]="subItem.displayName"
                                (keypress)="validatenumberOnly($event)"
                                maxlength="10"
                                (ngModelChange)="checkInputsFilled()"
                                />
                              </mat-form-field>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              }
              <!-- contact-->
              @for (item of adminData; track item) {
                @if (item.key === 'contact') {
                  <div class="sub-form">
                    <mat-icon class="icon-container">{{ item.iconPath }}</mat-icon>
                    <mat-label class="label">{{ item.displayName }}</mat-label>
                    <div class="margin-top-30"></div>
                    @for (subItem of contact; track subItem) {
                      <div class="margin-top-10"></div>
                      @if (showSubItem(subItem.key)) {
                        <div class="sub-input">
                          <mat-form-field appearance="outline" class="c_label">
                            <input
                              matInput
                              [(ngModel)]="subItem.value"
                              [placeholder]="subItem.displayName"
                              (ngModelChange)="checkInputsFilled(); contactInputsFilled()"
                              (keypress)="onKeyPress($event, subItem.key)"
                              (blur)="onBlur($event, subItem.key)"/>
                            </mat-form-field>
                            <div class="error-msg">
                              <span id="{{subItem.key}}-error" class="error-message"></span>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                }
              </div>
            </div>
          }
